import {
    AWS_COGNITO_CLIENT,
    AWS_COGNITO_DOMAIN,
    AWS_COGNITO_USER_POOL,
    COGNITO_FEDERATED_GOOGLE_SIGNIN_URL,
    COGNITO_FEDERATED_ISSUER,
    COGNITO_FEDERATED_SIGNOUT_URL,
    VY_COGNITO,
} from "../env";
import { getOrigin } from "./helpers";

export type AuthConfig = {
    domain: string | undefined;
    user_pool_id: string | undefined;
    client_id: string | undefined;
    urls: {
        login: string;
        logout: string;
    };
    issuer: string | undefined;
    flow: "sdk" | "oauth" | undefined;
};

const addCurrentOriginToQueryParams = (
    originalUrl: string,
    originKey: "redirect_uri" | "logout_uri",
) => {
    const url = new URL(originalUrl);
    const searchParams = url.searchParams;
    searchParams.set(originKey, getOrigin(document));
    url.search = searchParams.toString();
    return url.toString();
};

const toCognitoUrls = (
    domain: string,
    client_id: string,
): { login: string; logout: string } => {
    const redirectUrl = getOrigin(document);
    const server = `https://${domain}`;
    return {
        login: `${server}/login?response_type=token&client_id=${client_id}&redirect_uri=${redirectUrl}`,
        logout: `${server}/logout?client_id=${client_id}&logout_uri=${redirectUrl}`,
    };
};

export const AUTH_CONFIGS: {
    aws_cognito_conventional_login: AuthConfig;
    aws_cognito_federated_login_google: AuthConfig;
    aws_cognito_sso_enterprise_vy: AuthConfig | undefined;
} = {
    aws_cognito_conventional_login: {
        // username and password + optional mfa
        domain: AWS_COGNITO_DOMAIN,
        user_pool_id: AWS_COGNITO_USER_POOL,
        client_id: AWS_COGNITO_CLIENT,
        urls: toCognitoUrls(AWS_COGNITO_DOMAIN, AWS_COGNITO_CLIENT),
        issuer: undefined,
        flow: "sdk",
    },
    aws_cognito_federated_login_google: {
        domain: COGNITO_FEDERATED_GOOGLE_SIGNIN_URL
            ? new URL(COGNITO_FEDERATED_GOOGLE_SIGNIN_URL).hostname
            : undefined,
        user_pool_id: undefined,
        client_id: COGNITO_FEDERATED_GOOGLE_SIGNIN_URL
            ? new URL(COGNITO_FEDERATED_GOOGLE_SIGNIN_URL).searchParams.get(
                  "client_id",
              ) || undefined
            : undefined,
        urls: {
            login: addCurrentOriginToQueryParams(
                COGNITO_FEDERATED_GOOGLE_SIGNIN_URL,
                "redirect_uri",
            ),
            logout: addCurrentOriginToQueryParams(
                COGNITO_FEDERATED_SIGNOUT_URL,
                "logout_uri",
            ),
        },
        issuer: COGNITO_FEDERATED_ISSUER,
        flow: "oauth",
    },
    aws_cognito_sso_enterprise_vy:
        VY_COGNITO && VY_COGNITO.origin === getOrigin(document)
            ? {
                  domain: VY_COGNITO.domain,
                  user_pool_id: undefined,
                  client_id: VY_COGNITO.client_id,
                  urls: toCognitoUrls(VY_COGNITO.domain, VY_COGNITO.client_id),
                  issuer: undefined,
                  flow: "oauth",
              }
            : undefined,
} as const;
